__turbopack_context__.v({
  "animation-bubble": "Ingredients-module-scss-module__jUhoXq__animation-bubble",
  "bubbleTitle": "Ingredients-module-scss-module__jUhoXq__bubbleTitle",
  "fade-in": "Ingredients-module-scss-module__jUhoXq__fade-in",
  "heading": "Ingredients-module-scss-module__jUhoXq__heading",
  "ingredientBubble": "Ingredients-module-scss-module__jUhoXq__ingredientBubble",
  "ingredientBubble--open": "Ingredients-module-scss-module__jUhoXq__ingredientBubble--open",
  "ingredients": "Ingredients-module-scss-module__jUhoXq__ingredients",
  "list": "Ingredients-module-scss-module__jUhoXq__list",
  "toolTip": "Ingredients-module-scss-module__jUhoXq__toolTip",
});
